import { useQuery } from '@tanstack/react-query';
import { hostApi } from '../api/host';

export function useHostSummary() {
  return useQuery({
    queryKey: ['host', 'summary'],
    queryFn: hostApi.getSummary,
    refetchInterval: 20_000,
    staleTime: 10_000,
    retry: false,
  });
}
